export default "__VITE_ASSET__DtysML5L__"